<h2 i18n="section.signInMethods.form.linkEmailPassword.title">Set the new login method</h2>

<form [formGroup]="form" (ngSubmit)="onSubmit()" style="display: grid; gap: 12px; max-width: 420px;">
  <mat-form-field>
    <mat-label i18n="@@common.email">Email</mat-label>
    <input matInput type="email" [formControlName]="EmailPasswordLinkForm.FIELD_EMAIL">
    <mat-error *ngIf="form.get(EmailPasswordLinkForm.FIELD_EMAIL)?.hasError('required')" i18n="@@common.validation.emailRequired">Email is required</mat-error>
    <mat-error *ngIf="form.get(EmailPasswordLinkForm.FIELD_EMAIL)?.hasError('email')" i18n="@@common.validation.emailInvalid">Invalid email</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label i18n="@@common.password">Password</mat-label>
    <input matInput type="password" [formControlName]="EmailPasswordLinkForm.FIELD_PASSWORD">
    <mat-error *ngIf="form.get(EmailPasswordLinkForm.FIELD_PASSWORD)?.hasError('required')"
               i18n="@@common.validation.required">Required</mat-error>
    <mat-error *ngIf="form.get(EmailPasswordLinkForm.FIELD_PASSWORD)?.hasError('minlength')"
               i18n="@@common.validation.minLength">It must be at least {{passwordMinLength}} characters long.
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label i18n="@@common.confirmPassword">Confirm password</mat-label>
    <input matInput type="password" [formControlName]="EmailPasswordLinkForm.FIELD_PASSWORD_CONFIRM">
    <mat-error *ngIf="form.get(EmailPasswordLinkForm.FIELD_PASSWORD_CONFIRM)?.hasError('required')"
               i18n="@@common.validation.required">Required</mat-error>
    <mat-error *ngIf="form.get(EmailPasswordLinkForm.FIELD_PASSWORD_CONFIRM)?.hasError('mismatch')"
               i18n="@@common.validation.passwordMismatch">Passwords do not match</mat-error>
  </mat-form-field>

  <div style="display:flex; gap:8px; align-items:center; justify-content: right;">
    <button mat-stroked-button
            (click)="onCancel()"
            [disabled]="submitting">
      <ng-container i18n="@@common.action.cancel">Cancel</ng-container>
    </button>

    <button mat-flat-button color="primary" [disabled]="form.invalid || submitting">
      <ng-container *ngIf="!submitting" i18n="@@common.action.add">Add</ng-container>
      <ng-container *ngIf="submitting" i18n="@@common.action.adding">Adding…</ng-container>
    </button>
  </div>
</form>
